<template>
	<div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Rubro</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            placeholder="Digite un código..."
            id="codigo"
            name="codigo"
            v-model="form.codigo"
            :readonly="form.estado !== 'N'"
          >
            Código*
            <span
              v-if="errores.codigo"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.codigo[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="descripcion"
            v-model="form.descripcion"
            placeholder="Escriba una descripción..."
          >
            Descripción*
            <span
              v-if="errores.descripcion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.descripcion[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
			<div class="col-xs-12 col-md-6">
				<div class="form-inline">
					<label>
						<input v-model="form.tipo" type="radio" value="I" :disabled="form.estado !== 'N'">
						<span>Ingreso</span>
					</label>
					<label>
						<input v-model="form.tipo" type="radio" value="E" :disabled="form.estado !== 'N'">
						<span>Egreso</span>
					</label>
				</div>
			</div>
    </div>
    <div class="modal-buttons">
      <button @click="guardar" class="btn-success">
        <i class="fa fa-save"></i><span>Guardar</span>
      </button>
      <button @click="cancelar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
	props: {
		value: {
			type: Object,
			required: false,
			default: function () {
				return {
					id: "",
					codigo: "",
					descripcion: "",
					tipo: "",
					estado: "N"
				}
			}
		}
	},
	data: function () {
    return {
			form: JSON.parse(JSON.stringify(this.value)),
			errores: {},
		}
	},
	methods: {
		validarFormulario: function () {
			let tipo = this.form.tipo;
			if(tipo == null || tipo == ''){
				swal('Aviso', 'Debe seleccionar el tipo si es ingreso o egreso', 'warning');
				return false;
			}
			return true;
		},
		guardar: function () {
			if(!this.validarFormulario())
				return;
      swal({
        title: "¿Desea almacenar los datos del rubro?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let urlRequest = url + "/rubros-nomina";
          if (this.form.estado !== "N") {
            this.form._method = "PUT";
            urlRequest += "/" + this.form.id;
          } else this.form._method = undefined;
          axios
            .post(urlRequest, this.form)
            .then(() => {
              swal(
                "El rubro fue almacenado exitosamente.",
                "Realizado",
                "success"
              );
              this.$emit("saved");
            })
            .catch(({ response }) => {
              let status = response.status;
              if (status == 422) {
                this.errores = response.data.errors;
                swal("Hay errores en el formulario.", "Aviso", "warning");
              } else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
		cancelar: function () {
      this.$emit("cancelar");
    },
	}
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/nomina/RubroNomina.vue